// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_component_wrapper__KEUrv"};